// Turkish translations (Türkçe)
import type { TranslationKeys } from './en';

export const tr: TranslationKeys = {
  // Common
  common: {
    home: 'Ana Sayfa',
    settings: 'Ayarlar',
    language: 'Dil',
    loading: 'Yükleniyor...',
    save: 'Kaydet',
    cancel: 'İptal',
    confirm: 'Onayla',
    close: 'Kapat',
    back: '← Geri',
    continue: 'Devam',
    accept: 'Kabul Et',
    decline: 'Reddet',
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'Yeni Zelanda',
  },

  // Settings Menu
  settings: {
    header: 'Ayarlar',
    home: 'Ana Sayfa',
    howToPlay: 'Nasıl Oynanır',
    pieceRules: 'Taş Kuralları',
    language: 'Dil',
    manageSubscription: 'Aboneliği Yönet',
    gameHistory: 'Oyun Geçmişi',
    analytics: 'Analitik',
    premiumAccount: 'Premium Hesap',
    chatEnabled: 'Sohbet: Açık',
    chatDisabled: 'Sohbet: Kapalı',
  },

  // Piece Rules
  pieceRules: {
    title: 'Taş Kuralları',
    description: 'Taş hareketlerini öğrenin',
    selectPiece: 'Taş Seç',
    selectedLabel: 'Seçili:',
    statusLabel: 'Durum:',
    statusReady: 'Hazır',
    statusViewing: 'İzleniyor',
    movement: 'Hareket',
    regularMovement: 'Normal Hareket',
    ability: 'Yetenek',
    backToSelection: 'Seçime Geri Dön',
    backToHome: 'Ana Sayfaya Dön',
  },

  // Move/Ability Names
  moves: {
    movement: 'Hareket',
    savage: 'Vahşi',
    birdtype: 'Kuş Türü',
    birdType: 'Kuş Türü',
    wallBlock: 'Duvar Bloğu',
    moveblocks: 'Hareket Blokları',
    wallclimb: 'Duvar Tırmanışı',
    lilypad: 'Nilüfer Yaprağı',
    poisonous: 'Zehirli',
    meadow: 'Çayır',
    parasiticfungi: 'Parazit Mantar',
    zombification: 'Zombileştirme',
    fungi: 'Mantar',
    traverse: 'Geçiş',
    capture: 'Ele Geçirme',
    faint: 'Bayılma',
    leap: 'Sıçrama',
    swing: 'Sallanma',
    consume: 'Tüketme',
    gamble: 'Kumar',
    entangle: 'Dolaştırma',
    ink: 'Mürekkep',
    rotate: 'Dönme',
    backstep: 'Geri Adım',
    trample: 'Çiğneme',
    charge: '돌진',
    lane: 'Şerit',
    snakestrike: 'Yılan Saldırısı',
    shedskin: 'Deri Değiştirme',
    house: 'Ev',
    plant: 'Bitki Türü',
    planttype: 'Bitki Türü',
    capturehost: 'Konağı Ele Geçirme',
    contagion: 'Bulaşma',
    lonewolf: 'Yalnız Kurt',
    hop: 'Zıplama',
    decay: 'Çürüme',
    slide: 'Kayma',
    block: 'Blok',
    poison: 'Zehir',
    infection: 'Enfeksiyon',
    howl: 'Uluma',
  },

  // Animation Scenario Descriptions
  scenarios: {
    // Bear
    bearMovement: 'Ayı, satranç kralı gibi herhangi bir yöne bir kare hareket edebilir',
    bearMovementPost: 'Sadece dost taşlar tarafından engellenir (Ağaçlar hariç, Ayılar Ağaçlara tırmanabilir!)',
    bearSavage: 'Bir Ayı, Gergedan Bloğu gibi savunma yeteneklerini aşabilir',
    bearSavagePost: 'Vahşi kullanarak Ayı herhangi bir yönden herhangi bir taşı ele geçirebilir, öldürücülük katar',

    // Crane
    craneMovement: 'Turna, herhangi bir düz çizgide 1 veya 2 kare hareket edebilir',
    craneMovementPost: 'Turna diğer taşların üzerinden uçabilir!',
    craneBirdType: 'Kuş türü taşlar büyük veya yırtıcı taşları ele geçiremez',
    craneBirdTypePost: 'Bu Ağaç, Gergedan, Ayı ve Kurt\'u içerir',

    // Frog
    frogMovement: 'Kurbağa çapraz olarak 2 kare sıçrar',
    frogMovementPost: 'Sadece bir kare sıçrayamaz',
    frogWallBlock: 'Kurbağa\'nın normal 2 kare yolu bir duvar veya başka bir taş tarafından engellenirse ele geçiremez',
    frogWallBlockPost: 'Normal hareketi çapraz olarak 1 kareye kısalır',
    frogWallClimb: 'Kurbağa tahtanın duvarındayken (A veya E Sütunu) bir yukarı veya aşağı hareket edebilir',
    frogWallClimbPost: 'Dost bir taş veya Kurbağa\'nın önündeki bir Gergedan tarafından engellenmediği sürece',
    frogLilypad: 'Kurbağa bir oyunda henüz hareket etmediyse, güçlü bir savunma yeteneği olarak ilk 3 sıradan herhangi birine hareket edebilir',
    frogLilypadPost: 'Nilüfer Yaprağı Sıçraması kullanarak herhangi bir normal taşı ele geçirebilir, kendisinden daha yüksek sıradaki bir Gergedan hariç',
    frogPoisonous: 'Herhangi bir hayvan bir Kurbağa taşını ele geçirdiğinde zehirlenirsiniz!',
    frogPoisonousPost: 'Zehirlenmiş bir taş iyileşmeden önce bir sonraki uygun turunu atlar',

    // Fungi
    fungiMovement: 'Mantar herhangi bir yöne bir kare hareket edebilir',
    fungiMovementPost: 'Sadece müttefik taşlar tarafından engellenir',
    fungiMeadow: 'Mantar düşman Ağaç taşının hareket yeteneğini azaltır',
    fungiMeadowPost: 'Düşman Ağaç taşı Mantar taşından 1 kare içinde hareket edemez',
    fungiParasitic: 'Mantar düşman Ağaç taşını hareketsiz hale getirebilir',
    fungiParasiticPost: 'Mantar düşman Ağacın 1 karesi içindeyse, Mantar uzaklaşana veya ele geçirilene kadar hareket edemez',
    fungiZombification: 'Mantar kendini ele geçiren herhangi bir düşman hayvan taşını zombileştirebilir, bir tur boyunca düşman hayvanı kontrol etmeye izin verir',
    fungiZombificationPost: 'Zombileştirilmiş taş o tur için Mantar taşı olarak kabul edilir, Mantar kralınız olsa bile oyun o turdan sonra bitmez',
    fungiFungi: 'Mantar bir hayvan değil mantardır, bu nedenle birkaç etkiye karşı bağışıktır',
    fungiFungiPost: 'Zehir, dolaşma ve virüs enfeksiyonu gibi, ancak zombileştirme değil çünkü başkalarını zombileştirebilir!',

    // Goat
    goatMovement: 'Keçi herhangi bir yöne bir kare hareket edebilir',
    goatMovementPost: 'Keçi yavaş hareket eder ancak güçlü yeteneklere sahiptir',
    goatTraverse: 'Keçi devasa hareket potansiyeli yaratmak için diğer bağlı taşların üzerinden geçebilir',
    goatTraversePost: 'Keçi Bayılmış Keçiler veya Virüs gibi Küçük taşların üzerinden geçemez',
    goatCapture: 'Keçi hiçbir Yırtıcıyı ele geçiremez',
    goatCapturePost: 'Ayı veya Kurt gibi',
    goatFaint: 'Keçi Ağaç ve Gergedan gibi büyük taşlar dışında ele geçirilmekten kaçınmak için bayılabilir',
    goatFaintPost: 'Bayılmışken, rakipler hareketini durdurmak için bayılmış keçinin üzerinde "durabilir"',

    // Monkey
    monkeyMovement: 'Maymun herhangi bir yöne bir kare hareket edebilir',
    monkeyMovementPost: 'Kullanacak başka taşlar olmadan Maymun sınırlı harekete sahiptir',
    monkeyLeap: 'Maymun, dama oyunu gibi, devasa hareket potansiyeli için düz bir çizgide diğer taşların üzerinden sıçrayabilir',
    monkeyLeapPost: 'Ancak bir düşman taşın üzerinden sıçrarsa, Maymun sıçramayı atlatmak için zar atmalıdır, sıçradığı her düşman için 1/6 ele geçirilme şansı!',
    monkeySwing: 'Bir Maymun bir Ağacın üzerinden sıçrama kullanırsa, Maymun bonus tur kazanır',
    monkeySwingPost: 'Ağaç salıncağı kullanmak Maymun ve Ağaç taşları arasında güçlü bir sinerjik kombo yaratır',
    monkeyConsume: 'Maymun bonus tur için bir Mantar taşını tüketebilir',
    monkeyConsumePost: 'Diğer bonus turlarla birleştirildiğinde yıkıcı kombinasyonlara yol açar',
    monkeyGamble: 'Düşmanların üzerinden sıçramak için zar atmaya ek olarak, Maymun Ayıyı ele geçirmek için kumar oynamalıdır',
    monkeyGamblePost: 'Maymun Ayıyı ele geçirmek için 6 yüzlü bir zarda 5 veya 6 atmalıdır veya kendisi ele geçirilir',

    // Octopus
    octopusMovement: 'Ahtapot herhangi bir yöne bir kare hareket eder',
    octopusCapture: 'Ahtapot sadece dik olarak ele geçirebilir',
    octopusCapturePost: 'Ahtapot taşları karmaşık şekillerde ele geçirebilir veya dolaştırabilir, bu yüzden her zaman kırmızı ele geçirmeleri ve mor dolaştırmaları kontrol edin!',
    octopusEntangle: 'Ahtapot komşu düşman taşları dolaştırabilir, onları hareketsiz hale getirebilir, hatta bir kare hareket edip düşmanları dolaştırabilir!',
    octopusEntanglePost: 'Dolaşmış taşlar Ahtapot uzaklaşana veya ele geçirilene kadar hareket edemez',
    octopusInk: 'Ahtapot tehlikeli durumlardan kaçmak için mürekkep kullanabilir, 3\'e kadar gölge yaratır',
    octopusInkPost: 'Düşmanı şaşırtarak ilginç tuzak ve kaçış oyunlarına izin verir',

    // Penguin
    penguinMovement: 'Penguen belirlenen yönünde düz bir çizgide bir duvar veya taş hareketini engelleyene kadar kayar',
    penguinMovementPost: 'Hareket ettikten sonra, Penguen aynı tur içinde son yönünü de belirleyebilir',
    penguinRotate: 'Maçın başında bir Penguen aşağıya bakar ve kaymadan önce dönmelidir, ayrıca uyuyor olarak bilinir',
    penguinRotatePost: 'Herhangi bir konumdaki penguen hareket etmek yerine dönmeyi seçebilir',
    penguinBirdType: 'Penguen sınırlı ele geçirme yeteneklerine sahiptir, Turna gibi Ağaç, Gergedan, Ayı veya Kurt gibi büyük veya yırtıcı taşları ele geçiremez',
    penguinBirdTypePost: 'Ele geçirdikten sonra, Penguen stratejik konumlandırma için herhangi bir yöne dönebilir',

    // Rhino
    rhinoMovement: 'Gergedan sadece iki kare ileri hareket eder',
    rhinoMovementPost: 'Sadece 1 kare hareket edemez',
    rhinoBackStep: 'Gergedan geri-sol veya geri-sağ hareket edebilir',
    rhinoCharge: 'Gergedan oyun başına bir kez돌진 yeteneğini kullanarak bir ekstra kare ileri gidebilir',
    rhinoChargePost: 'Yıkıcı hareket ve ele geçirme potansiyeline yol açar',
    rhinoTrample: 'Gergedan Çiğneme ile seyahat yolundaki tüm taşları ele geçirir',
    rhinoTramplePost: 'Bayılmış bir Keçi taşı dahil',
    rhinoLane: 'Gergedan stratejik şerit oyununa izin vererek başka bir müttefik taşla yer değiştirebilir',
    rhinoLanePost: 'Ancak sadece Gergedan ve Müttefik taş ikisi de hareket etmediyse',

    // Snake
    snakeMovement: 'Yılan herhangi bir düz çizgide 2 kare hareket edebilir',
    snakeMovementPost: 'Yılan bir duvar veya dost taş tarafından engellenmediği sürece tam olarak 2 kare hareket eder',
    snakeMoveBlocks: 'Bir duvar veya ele geçiremeyeceği bir taş tarafından engellendiğinde, Yılan\'ın hareketi 1 kareye kısalır',
    snakeMoveBlocksPost: 'Ara bir taş olsa bile yine de iki kare hareket edebilir',
    snakeStrike: 'Yılan bir düşman hayvan varsa 3 kare ileri saldırabilir',
    snakeStrikePost: 'Ara taşlar yolunu engellemediği sürece',
    snakeShedskin: 'Oyun başına bir kez, kare boşsa Yılan derisini değiştirebilir ve ilk sıraya dönebilir',
    snakeShedskinPost: 'Bu yeniden doğuş Yılan\'a her oyunda ekstra bir can verir',

    // Tree
    treeMovement: 'Ağaç bir kare ileri veya sırasındaki herhangi bir kareye yan yana hareket edebilir',
    treeMovementPost: 'Yolu engellenmediği sürece',
    treeHouse: 'Ağaç diğer taşları barındırabilir, onları Ağaçlara tırmanamayan düşmanlardan korur. Belki taşlar Ayı, Turna, Kurbağa, Mantar, Keçi, Maymun, Ahtapot ve Yılan gibi tırmanabilir',
    treeHousePost: 'Bir ağaca tırmanabilen bir taş saldırdığında, sadece barındırılan taşı ele geçirir, Ağacı korur',
    treeTrample: 'Ağaç Gergedan gibi hareket ettiğinde bir karedeki tüm taşları ele geçirir',
    treeTramplePost: 'Bu bayılmış bir Keçi\'yi içerir',
    treePlant: 'Ağaç bir hayvan değil bitkidir, bu nedenle birkaç etkiye karşı bağışıktır',
    treePlantPost: 'Zehir, zombileştirme, dolaşma ve virüs enfeksiyonu gibi!',

    // Virus
    virusMovement: 'Virüs sadece iki kare uzaktaki hayvanlarla dolu karelere hareket edebilir',
    virusMoveBlocks: 'Virüs bir duvarın yanındaysa sadece bir kare hareket edebilir',
    virusCaptureHost: 'Virüs herhangi bir hayvan taşına indiğinde (içine girdiğinde), onları sadece enfekte eder, enfekte olmuş halde normal oyuna devam edebilirler',
    virusCaptureHostPost: 'Virüs taşı sadece enfekte konakçıdan ayrıldığında ele geçirir',
    virusContagion: 'Virüs tek turda birden fazla konakçıyı enfekte ederek hızla yayılabilir',
    virusContagionPost: 'Bulaşma Virüsün her turda istediği kadar yasal hamle yapmasına izin verir',

    // Wolf
    wolfMovement: 'Kurt satranç atı gibi L şeklinde hareket edebilir',
    wolfMovementPost: 'Diğer taşlar tarafından engellenmez',
    wolfLoneWolf: 'Kurt kalan müttefiklerine sahip olmadığında, hareket düzeni ekstra bir kare hareket eden uzatılmış bir L\'ye dönüşür',
    wolfLoneWolfPost: 'Kurt ayrıca hala bayılmış bir Keçi veya virüs müttefiki olduğunda kendini yalnız sayar',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 Keşfetmek için sürükleyin • Yakınlaştırmak için sıkıştırın',
    dragToExploreDesktop: '🖱️ Keşfetmek için sürükleyin • Yakınlaştırmak için kaydırın',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    failed: 'BAŞARISIZ!',
    success: 'BAŞARILI!',
    failedDefaultMessage: 'Pes etmeyin! Farklı bir yaklaşım deneyin.',
    superMessage: 'Mükemmel! Süper tamamlama elde ettiniz!',
    passMessage: 'Aferin! Öğretici tamamlandı!',
    tryAgain: 'Tekrar Dene',
    back: 'Geri',
    next: 'İleri',
    backToDev: 'Geliştirmeye Dön',
    backToTutorials: 'Öğreticilere Dön',
    continue: 'Devam',
    close: 'Kapat',
  },

  // Sandbox
  sandbox: {
    title: 'KUMA HAVUZU',
    description: 'Deney Yapın ve Pratik Yapın',
    mode: 'Mod:',
    modeValue: 'Kuma Havuzu',
    status: 'Durum:',
    statusReady: 'Hazır',
    clearBoard: 'Tahtayı Temizle',
  },

  // Multiplayer
  multiplayer: {
    title: 'ÇOK OYUNCULU',
    description: 'Eşleşmenizi bulun ve yarışın!',

    // Placement matches
    placementMatches: 'Yerleştirme Maçları',
    matchProgress: 'Maç İlerlemesi',
    gamesCompleted: '{games} / 10 Oyun Tamamlandı',
    estimatedFinalRating: 'Tahmini Nihai Sıralama',
    startingRating: 'Başlangıç sıralaması',
    matchesRemaining: '{matches} maç kaldı',
    findPlacementMatch: 'Yerleştirme Maçı Bul',

    // Matchmaking modes
    findMatch: 'Maç Bul',
    competitive: 'Rekabetçi',
    competitiveDesc: 'Sıralamaya yakın rakipler bulun',
    quick: 'Hızlı',
    quickDesc: 'Rekabetçi maçları hızlıca bulun',
    casual: 'Gündelik',
    casualDesc: 'Sıralanmamış - eğlence için oynayın!',
    placement: 'Yerleştirme',
    placementDesc: 'Sıralama almak için 10 maç tamamlayın',
    startSearch: 'Aramayı Başlat',

    // Searching
    searching: 'Aranıyor...',
    mode: 'Mod:',
    inQueue: 'Kuyrukta:',
    players: 'oyuncu',
    playersPlural: 'oyuncular',
    cancelSearch: 'Aramayı İptal Et',

    // Game info
    status: 'Durum:',
    ready: 'Hazır',
    selectingKing: 'Kral Seçiliyor',
    placingPieces: 'Taşlar Yerleştiriliyor',
    playing: 'Oynuyor',
    gameType: 'Oyun Türü:',
    opponent: 'Rakip:',
    opponentElo: 'Rakip ELO:',
    unranked: 'Sıralanmamış',

    // Piece placement
    dragPieces: 'Taşları tahtaya sürükleyin',
    lightPieces: 'Açık Taşlar (Siz)',
    darkPieces: 'Koyu Taşlar (Siz)',

    // Waiting states
    waitingForOpponent: 'Rakip Bekleniyor...',
    waitingForKing: 'Rakibin kralını seçmesi bekleniyor...',

    // Warnings
    invalidPlacement: 'Geçersiz Yerleştirme',
    lightTurn: 'Açık oyuncunun sırası!',
    darkTurn: 'Koyu oyuncunun sırası!',
    onlyLightPieces: 'Sadece açık taşları yerleştirebilirsiniz!',
    onlyDarkPieces: 'Sadece koyu taşları yerleştirebilirsiniz!',
    mustPlaceOnRow: '{color} taşlar {row} sırasına yerleştirilmelidir!',

    // Chat
    chat: 'Sohbet',
    typeMessage: 'Bir mesaj yazın...',
    send: 'Gönder',
    rematchRequest: 'Rövanş İsteği',
    rematchMessage: '{opponentUsername} tekrar oynamak istiyor!',
  },

  // Main Page
  mainPage: {
    title: 'HAYVAN SATRANCı',
    subtitle: 'İnsanlar için bir oyun',
    playersOnline: 'Şu anda çevrimiçi oyuncular',
    placement: 'Yerleştirme',
    placementProgress: 'Yerleştirme',
    challengeAI: 'Yapay Zekaya Meydan Oku',
    multiplayer: 'Çok Oyunculu',
    sandbox: 'Kuma Havuzu',
    tutorials: 'Öğreticiler',
    shop: 'Mağaza',
    collection: 'Koleksiyon',
    history: 'Geçmiş',
    analytics: 'Analitik',
    courses: 'Kurslar',
    upgradeAccount: 'Hesabı yükselt',
    signIn: 'Giriş Yap',
    playAsGuest: 'Misafir Olarak Oyna',
    welcomeBack: 'Tekrar hoş geldiniz! Genellikle şu şekilde oynarsınız',

    // Learn the Pieces section
    learnThePieces: 'Taşları öğrenin',

    // Learn the Rules section
    learnTheRules: 'Kuralları Öğrenin',
    premiseTitle: 'Öncül',
    premiseText: 'Zodiac, 13 taş listesinden GİZLİ bir kralı olan bir satranç alternatifidir, benzersiz bir kadro seçin ve ardından rakibinizi 5\'e 8 tahtada yenmek için blöf yapın',
    selectionTitle: 'Seçim',
    selectionText: 'Bir oyuna başlamak için gizlice kralınızı seçin, ardından rakibinizle dönüşümlü olarak 5 taşınızı yerleştirerek 500 milyardan fazla başlangıç durumundan birini oluşturun.',
    objectiveTitle: 'Amaç',
    objectiveText: 'Ya rakibinizi okuyarak gizli kralını ELE GEÇİRİN ya da zaferi garantilemek için kralınızı tahtanın karşısına KOŞTURUN!',
    competeTitle: 'Yarışın',
    competeText: 'Merdivendeki becerilerinizi test edin, yeni kişisel teknikler ve stratejiler geliştirin, en iyileriyle savaşmak için sıralamanızı yükseltin!',
    fullRulesButton: 'Tam resmi kurallar için buraya tıklayın',

    // FAQ section
    faqTitle: 'Sıkça Sorulan Sorular',
    faqQuestion1: 'Zodiac satrancının ardındaki fikir nedir?',
    faqAnswer1: 'Zodiac satranç başlangıçta Bobby Fischer\'ın Chess960\'ı yaratma ilhamı hakkındaki sözlerinden ilham aldı, ezberlemeyle savaşma ve insani sezgiyi dipsiz derinlikte kutlama fikrini genişletmek istedik!',
    faqQuestion2: 'Neden bir satranç alternatifine ihtiyacımız var',
    faqAnswer2: 'İhtiyacımız yok! Zodiac insanları satranç oynamaktan caydırmak istemiyor! Kendi güçlü ve zayıf yönleri olan farklı bir seçenek, umarız eğlenirsiniz ve yeni oyunları canlandırmak için bu oyunu uyarlamamıza yardımcı olursunuz',
    faqQuestion3: 'Zodiac Satrancında nasıl kazanılır?',
    faqAnswer3: 'Kazanmanın üç yolu vardır: rakibinizin gizli kral taşını ele geçirin, kendi kralınızı tahtanın karşı tarafına koşturun veya zaman kontrollü bir maçta rakibinizin zamanı bitsin',
    faqQuestion4: 'Bu bir SSS mı?',
    faqAnswer4: 'Evet, SSS\'deki listelenen sorulardan herhangi birine bakabilirsiniz ve daha fazla ayrıntı istiyorsanız, sorulara tıklayabilir ve ardından şu anda okuduğunuz bu ayrıntılar gibi aşağıdaki ayrıntıları okuyabilirsiniz',
    faqQuestion5: 'Tipik bir oyun ne kadar sürer?',
    faqAnswer5: 'Her oyun büyük ölçüde farklılık gösterir! Bazı oyunlar 2 hamlede biter ve bazıları 30 dakika sürebilir, genellikle 5-15 dakika aralığında buluruz!',
    faqQuestion6: 'Kimse yasal hamle yapamazsa ne olur?',
    faqAnswer6: 'Bir oyuncu yasal hamle yapamazsa (pat), oyun beraberlikle biter. Oyun ayrıca tekrarla (aynı tahta durumu 3 kez) veya oyuncular arasında karşılıklı anlaşmayla beraberlikle bitebilir!',

    // About section
    aboutButton: 'Hakkında',
    privacyPolicy: 'Gizlilik Politikası',
    developerInterface: 'Geliştirici Arayüzü',
  },

  // About Modal
  about: {
    title: 'Zodiac Hakkında',
    paragraph1: 'Zodiac, LoL ve DotA gibi oyunlardan taş seçimi öğelerini poker veya sosyal çıkarım oyunlarından blöf mekanikleriyle birleştiren satranca benzer bir tahta oyunudur.',
    paragraph2: 'Oyunun ilk versiyonları 2014\'te Shadow Chess adı altında yaratıldı. 2018\'de bugün gördüğünüz haline yeniden tasarlandı, dengeli ama benzersiz hareket kalıpları ve yeteneklere sahip eğlenceli taşlardan oluşan bir kadro içeriyor.',
    paragraph3: 'Vizyonumuz, oyun dengesini yenileyici tutmak, yeni oyunları teşvik etmek amacıyla oyunu geliştirmeye devam etmek için tüm kullanıcı oyun verilerini kaydetmektir.',
    paragraph4: 'Zodiac\'ın devasa arama alanı, gizli bilgi ve açılış tahta pozisyonlarıyla yapay zeka hakimiyetini önlemeyi ve zodiac\'ı insanlar için bir oyun olarak tutmayı umuyoruz!',
  },

  // Privacy Policy
  privacy: {
    title: 'Gizlilik Politikası',
    lastUpdated: 'Son Güncelleme',

    introduction: {
      title: 'Giriş',
      p1: 'Zodiac Chess\'e ("biz", "bizim" veya "bize") hoş geldiniz. Gizliliğinizi korumaya ve güvenli ve keyifli bir oyun deneyimi sağlamaya kararlıyız. Bu Gizlilik Politikası, web sitemizi ve oyunumuzu kullandığınızda bilgilerinizi nasıl topladığımızı, kullandığımızı, ifşa ettiğimizi ve koruduğumuzu açıklar.',
      p2: 'Zodiac Chess\'i kullanarak, bilgilerin bu politikaya uygun olarak toplanmasını ve kullanılmasını kabul edersiniz. Politikalarımızı ve uygulamalarımızı kabul etmiyorsanız, lütfen hizmetimizi kullanmayın.',
      contact: 'Bizimle iletişime geçin:',
    },

    infoCollect: {
      title: 'Topladığımız Bilgiler',
      accountInfo: {
        title: '1. Hesap Bilgileri',
        item1: 'E-posta Adresi: Hesap oluşturma ve iletişim için gerekli',
        item2: 'Kullanıcı Adı: Seçtiğiniz görüntüleme adı',
        item3: 'Şifre: Şifrelenmiş ve güvenli bir şekilde saklanmış',
      },
      gameData: {
        title: '2. Oyun Verileri',
        item1: 'Oyun İstatistikleri: Kazanma, kaybetme, ELO sıralaması, yerleştirme maçı ilerlemesi',
        item2: 'Oynanış Verileri: Taş seçimleri, yapılan hamleler, kullanılan stratejiler',
        item3: 'Maç Geçmişi: Oynanan oyunların kayıtları, karşılaşılan rakipler',
        item4: 'Oyun İçi Satın Almalar: Kozmetik ürünler ve premium üyelik durumu',
      },
      technicalData: {
        title: '3. Teknik Veriler',
        item1: 'Cihaz Bilgileri: Tarayıcı türü, işletim sistemi',
        item2: 'Kullanım Verileri: Ziyaret edilen sayfalar, harcanan zaman, kullanılan özellikler',
        item3: 'Yerel Depolama: Dil tercihleri, UI ayarları, geçici oyun durumu',
      },
    },

    children: {
      title: 'Çocukların Gizliliği (COPPA Uyumluluğu)',
      p1: 'Zodiac Chess aile dostu olacak şekilde tasarlanmıştır ve çocuklar dahil her yaştan oyuncu için uygundur. Çocukların Çevrimiçi Gizlilik Koruma Yasası\'na (COPPA) uymak için özel özen gösteriyoruz.',
      p2: '13 yaşından küçük kullanıcılar için: Çocukların hesap oluşturma veya veri toplama gerektirmeyen misafir oyun modunu kullanmalarını öneriyoruz. Misafir hesapların metin sohbet özelliklerine erişimi yoktur, bu da çocukların daha geniş internetle iletişime maruz kalmamasını sağlar. Bir çocuk hesap oluşturursa, herhangi bir kişisel bilgi toplamadan önce ebeveyn onayı gerektiririz.',
      p3: 'Doğrulanmış ebeveyn onayı olmadan 13 yaşından küçük çocuklardan bilerek kişisel bilgi TOPLAMAYIZ, KULLANMAYIZ veya PAYLAŞMAYIZ.',
      p4: 'Sohbet Güvenliği: Metin sohbet tüm misafir/geçici hesaplar için otomatik olarak devre dışıdır. Standart hesap sahipleri hesap ayarlarında sohbet işlevini istedikleri zaman devre dışı bırakma seçeneğine sahiptir.',
      parentalRights: 'Ebeveynlerin hakları:',
      right1: 'Çocuklarının kişisel bilgilerini incelemek',
      right2: 'Çocuklarının verilerinin silinmesini talep etmek',
      right3: 'Çocuklarının bilgilerinin daha fazla toplanmasını veya kullanılmasını reddetmek',
      contactUs: 'Bu hakları kullanmak için veya çocuğunuzun bize kişisel bilgi verdiğine inanıyorsanız, lütfen derhal contact@zodiac-chess.com adresinden bizimle iletişime geçin',
    },

    howWeUse: {
      title: 'Bilgilerinizi Nasıl Kullanırız',
      item1: 'Oyun hizmetlerimizi sağlamak ve geliştirmek',
      item2: 'Sizi beceri düzeyine göre uygun rakiplerle eşleştirmek',
      item3: 'İlerlemenizi, istatistiklerinizi ve başarılarınızı izlemek',
      item4: 'Premium üyelikler ve kozmetik ürünler için ödemeleri işlemek',
      item5: 'Önemli hizmet duyuruları ve güncellemeleri göndermek',
      item6: 'Oyun dengesini ve özellikleri geliştirmek için oyun verilerini analiz etmek',
    },

    thirdParty: {
      title: 'Üçüncü Taraf Hizmetler',
      firebase: {
        title: 'Firebase (Google)',
        description: 'Kimlik doğrulama, veritabanı depolama ve çok oyunculu işlevsellik için Firebase kullanıyoruz. Firebase gizlilik politikasında açıklandığı gibi belirli verileri toplayabilir.',
      },
      stripe: {
        title: 'Stripe',
        description: 'Premium üyelikler ve uygulama içi satın almalar için ödemeleri işlemek için Stripe kullanıyoruz. Stripe tüm ödeme kartı bilgilerini işler - tam ödeme bilgilerinizi asla görmez veya saklamayız.',
      },
      netlify: {
        title: 'Netlify',
        description: 'Web sitemiz Netlify\'da barındırılır, IP adresleri ve erişim günlükleri gibi standart web barındırma verilerini toplayabilir.',
      },
      adsense: {
        title: 'Google AdSense (Gelecek)',
        description: 'Google AdSense aracılığıyla reklamlar gösterebiliriz. Bu reklamlar kişiselleştirme için çerezler kullanabilir. Çocuklara yönelik içerik için COPPA\'ya uygun olarak yalnızca kişiselleştirilmemiş reklamlar göstereceğiz.',
      },
      viewPolicy: 'Gizlilik Politikalarını Görüntüle',
    },

    cookies: {
      title: 'Çerezler ve Yerel Depolama',
      description: 'Deneyiminizi geliştirmek için tarayıcı yerel depolaması (çerezlere benzer) kullanıyoruz:',
      item1: 'Dil Tercihi: Seçtiğiniz dili hatırlamak',
      item2: 'Hesap Oturumu: Oturumunuzu açık tutmak (Firebase ile çalışır)',
      item3: 'Oyun Ayarları: UI tercihlerinizi ve kuma havuzu kurulumlarınızı hatırlamak',
      item4: 'Reklam Çerezleri: Onay verirseniz, üçüncü taraf reklam hizmetleri reklam kişiselleştirmesi için çerezler kullanabilir',
    },

    security: {
      title: 'Veri Güvenliği',
      p1: 'Bilgilerinizi korumak için uygun güvenlik önlemleri uyguluyoruz:',
      item1: 'Şifre Şifreleme: Tüm şifreler endüstri standardı yöntemler kullanılarak şifrelenir',
      item2: 'Güvenli Bağlantılar: Tüm veri iletimi için HTTPS şifreleme',
      item3: 'Firebase Güvenlik Kuralları: Katı veritabanı erişim kontrolleri',
      p2: 'Ancak, internet üzerinden hiçbir iletim yöntemi %100 güvenli değildir. Verilerinizi korumak için çaba göstermemize rağmen, mutlak güvenliği garanti edemeyiz.',
    },

    retention: {
      title: 'Veri Saklama',
      p1: 'Verilerinizi şu şekilde saklarız:',
      item1: 'Aktif Hesaplar: Hesabınız aktifken veriler saklanır',
      item2: 'Pasif Hesaplar: Hesabınız 10 yıl boyunca pasifse, verilerinizi silebiliriz',
    },

    rights: {
      title: 'Gizlilik Haklarınız',
      description: 'Konumunuza bağlı olarak aşağıdaki haklara sahip olabilirsiniz:',
      access: {
        title: 'Erişim:',
        description: 'Kişisel verilerinizin bir kopyasını talep edin',
      },
      correction: {
        title: 'Düzeltme:',
        description: 'Verilerinizde düzeltme talep edin',
      },
      deletion: {
        title: 'Silme:',
        description: 'Hesabınızın ve verilerinizin silinmesini talep edin',
      },
      portability: {
        title: 'Veri Taşınabilirliği:',
        description: 'Verilerinizi taşınabilir bir formatta talep edin',
      },
      optOut: {
        title: 'Vazgeçme:',
        description: 'Pazarlama iletişimlerinden vazgeçin',
      },
      contact: 'Bu haklardan herhangi birini kullanmak için lütfen contact@zodiac-chess.com adresinden bizimle iletişime geçin',
    },

    international: {
      title: 'Uluslararası Kullanıcılar',
      p1: 'Zodiac Chess Yeni Zelanda\'dan işletilmektedir. Hizmetimize Yeni Zelanda dışından erişiyorsanız, bilgilerinizin Yeni Zelanda\'ya ve hizmet sağlayıcılarımızın faaliyet gösterdiği diğer ülkelere aktarılabileceğini, saklanabileceğini ve işlenebileceğini lütfen unutmayın.',
      p2: 'Hizmetimizi kullanarak, bilgilerinizin farklı veri koruma yasalarına sahip olabilecek ikamet ülkenizin dışındaki ülkelere aktarılmasına izin vermiş olursunuz.',
    },

    changes: {
      title: 'Bu Gizlilik Politikasındaki Değişiklikler',
      description: 'Bu Gizlilik Politikasını zaman zaman güncelleyebiliriz. Yeni Gizlilik Politikasını bu sayfada yayınlayarak ve "Son Güncelleme" tarihini güncelleyerek değişiklikler hakkında sizi bilgilendireceğiz. Önemli değişiklikler e-posta veya web sitemizde belirgin bir bildirim aracılığıyla iletilecektir.',
    },

    contact: {
      title: 'Bizimle İletişime Geçin',
      description: 'Bu Gizlilik Politikası veya veri uygulamalarımızla ilgili herhangi bir sorunuz, endişeniz veya talebiniz varsa, lütfen bizimle iletişime geçin:',
      email: 'E-posta:',
      company: 'Şirket:',
    },

    cookieConsent: {
      title: 'Cookie Consent & Control',
      p1: 'We believe in transparency and giving you control over your data. When you first visit Zodiac Chess, you will be presented with a cookie consent banner that allows you to choose which types of cookies you want to accept.',
      categories: {
        title: 'Cookie Categories',
        necessary: {
          title: 'Necessary Cookies',
          description: ' These cookies are essential for the website to function properly. They enable core features like authentication, game state management, and security. You cannot opt out of these cookies.',
        },
        analytics: {
          title: 'Analytics Cookies',
          description: ' These cookies help us understand how visitors interact with our website by collecting anonymous usage data through Firebase Analytics. This helps us improve the game experience.',
        },
        advertising: {
          title: 'Advertising Cookies',
          description: ' These cookies are used by Google AdSense to display personalized advertisements. Premium members never see ads, regardless of consent settings.',
        },
      },
      control: {
        title: 'How to Control Cookies',
        p1: 'You have several options to manage your cookie preferences:',
        method1: 'Cookie Banner: On your first visit, you can accept all cookies, reject optional cookies, or customize your preferences.',
        method2: 'Browser Settings: Most browsers allow you to refuse or delete cookies through their settings menu.',
        method3: 'Opt-Out Links: For advertising cookies, you can opt out of personalized ads using the links below.',
      },
      optOut: {
        title: 'Opt Out of Personalized Advertising',
        p1: 'If you would like to opt out of personalized advertising from Google and other ad networks, you can use these resources:',
        googleAds: 'Google Ad Settings - Manage Google personalized ads',
        daa: 'Digital Advertising Alliance (DAA) - Opt out of interest-based ads',
        eaa: 'European Interactive Digital Advertising Alliance (EDAA) - EU users opt-out',
      },
      moreInfo: 'For more detailed information about the cookies we use, please visit our',
      cookiePolicyLink: 'Cookie Policy',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: 'We Value Your Privacy',
    description: 'We use cookies to enhance your experience, analyze site usage, and show personalized ads (for free users only). You can customize your preferences at any time.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Optional',
    customize: 'Customize',
    savePreferences: 'Save Preferences',
    back: 'Back',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'Required for the site to function. These cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    advertising: 'Advertising Cookies',
    advertisingDesc: 'Used to show personalized ads (free users only, premium members never see ads).',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
  },

  // Terms of Service
  terms: {
    title: 'Kullanım Koşulları',
    lastUpdated: 'Son Güncelleme',
    acknowledgment: 'Zodiac Chess kullanarak, bu Kullanım Koşullarını okuduğunuzu, anladığınızı ve bunlara bağlı olmayı kabul ettiğinizi onaylıyorsunuz.',
    viewPrivacyPolicy: 'Gizlilik Politikasını Görüntüle',
    back: 'Geri',
    acceptance: {
      title: '1. Koşulların Kabulü',
      p1: 'Zodiac Chess\'e ("Hizmet") erişerek ve kullanarak, bu Kullanım Koşullarına bağlı olmayı kabul edersiniz. Bu koşulları kabul etmiyorsanız, lütfen Hizmeti kullanmayın.',
      p2: 'Bu koşulları istediğimiz zaman değiştirme hakkını saklı tutarız. Değişikliklerden sonra Hizmeti kullanmaya devam etmeniz, değiştirilen koşulları kabul ettiğiniz anlamına gelir.',
    },
    description: {
      title: '2. Hizmet Açıklaması',
      p1: 'Zodiac Chess, özel yeteneklere sahip benzersiz hayvan taşlarına sahip çevrimiçi bir strateji masa oyunudur. Hizmet şunları içerir:',
      feature1: 'Yapay zeka rakiplerine karşı tek oyunculu oyun',
      feature2: 'Çok oyunculu eşleştirme ve rekabetçi oyun',
      feature3: 'Etkileşimli öğreticiler ve öğrenme kaynakları',
      feature4: 'Hesap oluşturma ve ilerleme takibi',
      feature5: 'İsteğe bağlı premium abonelik özellikleri',
      feature6: 'Kozmetik özelleştirme seçenekleri',
    },
    accounts: {
      title: '3. Kullanıcı Hesapları',
      eligibility: {
        title: '3.1 Uygunluk',
        p1: 'Hesap oluşturmak için en az 13 yaşında olmalısınız. 13 yaşın altındaki kullanıcılar ebeveyn gözetiminde misafir oyun modunu kullanabilir ancak hesap oluşturamazlar.',
      },
      responsibilities: {
        title: '3.2 Hesap Güvenliği',
        p1: 'Şunlardan sorumlusunuz:',
        item1: 'Şifrenizin gizliliğini korumak',
        item2: 'Hesabınız altında gerçekleşen tüm faaliyetler',
        item3: 'Yetkisiz kullanımı derhal bize bildirmek',
        p2: 'Yetkisiz hesap erişiminden kaynaklanan herhangi bir kayıp veya hasardan sorumlu değiliz.',
      },
      prohibited: {
        title: '3.3 Yasaklı Faaliyetler',
        p1: 'Şunları YAPAMAZSINIZ:',
        item1: 'Hesabınızı başkalarıyla paylaşmak',
        item2: 'Sıralamaları manipüle etmek için birden fazla hesap kullanmak',
        item3: 'Oyun oynamak için botlar, scriptler veya otomatik araçlar kullanmak',
        item4: 'Diğer oyuncuları taciz etmek, kötüye kullanmak veya tehdit etmek',
        item5: 'Haksız avantaj için hataları veya aksaklıkları kullanmak',
        item6: 'Tersine mühendislik yapmak veya kaynak kodumuza erişmeye çalışmak',
        p2: 'Bu kuralların ihlali hesap askıya alınmasına veya kalıcı yasaklamaya neden olabilir.',
      },
    },
    premium: {
      title: '4. Premium Abonelikler',
      billing: {
        title: '4.1 Faturalandırma',
        p1: 'Premium abonelikler Stripe aracılığıyla işlenir. Premium abonelik satın alarak, iptal edene kadar ödeme yönteminizi düzenli olarak ücretlendirmemize yetki verirsiniz.',
        p2: 'Abonelik ücretleri:',
        item1: 'Aylık Plan: Satın alma tarihinizin yıldönümünde aylık olarak ücretlendirilir',
        item2: 'Yıllık Plan: Satın alma tarihinizin yıldönümünde yıllık olarak ücretlendirilir',
        p3: 'Fiyatlar, aktif abonelere 30 gün önceden bildirimle değiştirilebilir.',
      },
      cancellation: {
        title: '4.2 İptal',
        p1: 'Aboneliğinizi istediğiniz zaman hesap ayarlarınızdan veya destekle iletişime geçerek iptal edebilirsiniz. İptal, mevcut faturalandırma döneminin sonunda yürürlüğe girer.',
        p2: 'İptal ettikten sonra bile ödenen dönemin sonuna kadar premium özelliklerini korursunuz.',
      },
      refunds: {
        title: '4.3 Geri Ödemeler',
        p1: 'Aylık abonelikler: Kısmi aylar için geri ödeme yoktur. Gelecekteki ücretleri durdurmak için istediğiniz zaman iptal edin.',
        p2: 'Yıllık abonelikler: Satın almadan sonraki 7 gün içinde talep edilirse tam geri ödeme. 7 günden sonra geri ödemeler bizim takdirimize bağlıdır.',
        p3: 'Kozmetik satın almalar: Genellikle iade edilmez. Olağanüstü durumlar için destekle iletişime geçin.',
      },
    },
    acceptable: {
      title: '5. Kabul Edilebilir Kullanım Politikası',
      p1: 'Zodiac Chess\'i saygılı ve yasal bir şekilde kullanmayı kabul edersiniz. Yasaklanan davranışlar şunlardır:',
      item1: 'Hile yapmak, hacklemek veya oyun mekaniklerini istismar etmek',
      item2: 'Taciz, nefret söylemi veya ayrımcı dil',
      item3: 'Spam yapmak, reklam yapmak veya talep etmek',
      item4: 'Uygunsuz içerik paylaşmak (sohbet veya kullanıcı tarafından oluşturulan içerik etkinse)',
      item5: 'Diğer kullanıcıları veya personeli taklit etmek',
      item6: 'Hizmeti bozmaya veya zarar vermeye çalışmak',
      p2: 'İhlalleri araştırma ve hesap sonlandırma ve gerekirse yetkililere bildirme dahil uygun önlemleri alma hakkını saklı tutarız.',
    },
    intellectual: {
      title: '6. Fikri Mülkiyet Hakları',
      ownership: {
        title: '6.1 İçeriğimiz',
        p1: 'Oyun mekanikleri, sanat eserleri, animasyonlar, ses efektleri, kod ve tasarım dahil ancak bunlarla sınırlı olmamak üzere tüm oyun içeriği Animal Chess Limited veya lisans verenlerimize aittir.',
        p2: 'Hizmeti yalnızca kişisel eğlence amaçları için kullanmak üzere sınırlı, münhasır olmayan, devredilemez bir lisans verilmiştir.',
      },
      userContent: {
        title: '6.2 Kullanıcı İçeriği',
        p1: 'İçerik göndererek (sohbet mesajları, kullanıcı adları veya profil bilgileri gibi), bu içeriği Hizmetle bağlantılı olarak kullanmak, görüntülemek ve dağıtmak için bize dünya çapında, telifsiz bir lisans verirsiniz.',
        p2: 'Gönderdiğiniz herhangi bir içeriğin sahibi olduğunuzu veya gerekli haklara sahip olduğunuzu beyan edersiniz.',
      },
    },
    disclaimers: {
      title: '7. Sorumluluk Reddi ve Sınırlamalar',
      p1: 'HİZMET, AÇIK VEYA ZIMNİ HERHANGİ BİR GARANTİ OLMAKSIZIN "OLDUĞU GİBİ" SAĞLANMAKTADIR.',
      p2: 'Şunları garanti etmiyoruz:',
      item1: 'Hizmetin kesintisiz veya hatasız olacağını',
      item2: 'Kusurların düzeltileceğini',
      item3: 'Hizmetin virüslerden veya zararlı bileşenlerden arındırılmış olduğunu',
      item4: 'Hizmeti kullanmanın sonuçlarının beklentilerinizi karşılayacağını',
      p3: 'YASALARIN İZİN VERDİĞİ AZAMİ ÖLÇÜDE, ŞU DURUMLARDAN SORUMLU DEĞİLİZ:',
      item5: 'Dolaylı, arızi veya sonuç olarak ortaya çıkan zararlar',
      item6: 'Kar, veri veya itibar kaybı',
      item7: 'Hizmet kesintileri veya veri kaybı',
      item8: 'Son 12 ayda bize ödediğiniz miktarı aşan zararlar',
    },
    privacy: {
      title: '8. Gizlilik',
      p1: 'Hizmeti kullanımınız ayrıca kişisel bilgilerinizi nasıl topladığımızı, kullandığımızı ve koruduğumuzu açıklayan Gizlilik Politikamız tarafından yönetilir.',
      p2: 'Hizmeti kullanarak, Gizlilik Politikasında açıklandığı şekilde veri uygulamalarımızı kabul etmiş olursunuz.',
    },
    changes: {
      title: '9. Koşullardaki Değişiklikler',
      p1: 'Bu Kullanım Koşullarını istediğimiz zaman değiştirme hakkını saklı tutarız. Önemli değişiklikleri kullanıcılara şu yollarla bildireceğiz:',
      item1: 'Kayıtlı kullanıcılara e-posta bildirimi',
      item2: 'Web sitesinde belirgin duyuru',
      item3: 'Bu sayfanın üst kısmında güncellenmiş "Son Güncelleme" tarihi',
      p2: 'Değişikliklerden sonra Hizmeti kullanmaya devam etmeniz, değiştirilen koşulları kabul ettiğiniz anlamına gelir.',
    },
    governing: {
      title: '10. Geçerli Hukuk',
      p1: 'Bu Kullanım Koşulları, kanunlar çatışması ilkelerine bakılmaksızın Yeni Zelanda yasalarına tabidir.',
      p2: 'Bu koşullardan veya Hizmeti kullanımınızdan kaynaklanan herhangi bir anlaşmazlık Yeni Zelanda mahkemelerinde çözülecektir.',
    },
    contact: {
      title: '11. İletişim Bilgileri',
      p1: 'Bu Kullanım Koşulları ile ilgili sorular, endişeler veya destek için:',
      email: 'E-posta:',
      company: 'Şirket:',
      address: 'Adres:',
    },
    severability: {
      title: '12. Bölünebilirlik',
      p1: 'Bu koşulların herhangi bir hükmünün uygulanamaz veya geçersiz bulunması halinde, bu hüküm gerekli olan asgari ölçüde sınırlandırılacak veya ortadan kaldırılacak ve kalan hükümler tam olarak yürürlükte kalmaya devam edecektir.',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: 'Cookie Policy',
    lastUpdated: 'Last Updated',
    browserInstructions: {
      chrome: 'Chrome: Ayarlar → Gizlilik ve Güvenlik → Çerezler',
      firefox: 'Firefox: Ayarlar → Gizlilik ve Güvenlik → Çerezler ve Site Verileri',
      safari: 'Safari: Tercihler → Gizlilik → Çerezler ve web sitesi verileri',
      edge: 'Edge: Ayarlar → Gizlilik, arama ve hizmetler → Çerezler',
    },
    cookieTable: {
      name: 'Ad',
      purpose: 'Amaç',
      duration: 'Süre',
      type: 'Tür',
    },
    relatedPolicies: {
      title: 'İlgili Politikalar',
      description: 'Verilerinizi nasıl işlediğimiz hakkında daha fazla bilgi için lütfen bakın:',
      privacy: 'Gizlilik Politikası',
      terms: 'Kullanım Koşulları',
    },
    introduction: {
      title: 'Giriş',
      p1: 'Bu Çerez Politikası, Zodiac Chess\'in ("biz" veya "bizim") web sitemizi ziyaret ettiğinizde çerezleri ve benzer teknolojileri nasıl kullandığını açıklar.',
      p2: 'Web sitemizi kullanarak, bu politikaya uygun olarak çerez kullanımımızı kabul etmiş olursunuz. Kabul etmiyorsanız, lütfen tarayıcı ayarlarınızda çerezleri devre dışı bırakın veya web sitemizi kullanmayın.',
    },
    what: {
      title: 'Çerezler Nedir?',
      p1: 'Çerezler, bir web sitesini ziyaret ettiğinizde cihazınıza (bilgisayar, akıllı telefon, tablet) yerleştirilen küçük metin dosyalarıdır. Web sitelerinin verimli çalışmasını sağlamak ve web sitesi sahiplerine bilgi sağlamak için yaygın olarak kullanılırlar.',
      p2: 'Çerezler, tercihlerinizi hatırlama, site kullanımını analiz etme ve belirli özellikleri etkinleştirme dahil çeşitli amaçlara hizmet eder.',
    },
    types: {
      title: 'Kullandığımız Çerez Türleri',
      necessary: {
        title: '1. Gerekli Çerezler',
        description: 'Bu çerezler, web sitesinin düzgün çalışması için gereklidir. Bu çerezler olmadan, talep ettiğiniz hizmetler sağlanamaz.',
        examples: 'Örnekler:',
        item1: 'Kimlik doğrulama çerezleri - Hesabınızda oturum açık kalmanızı sağlar',
        item2: 'Güvenlik çerezleri - Dolandırıcılık faaliyetlerine karşı korur',
        item3: 'Oturum çerezleri - Bir oturum sırasında oyun durumunuzu korur',
        item4: 'Çerez onayı tercihleri - Çerez seçimlerinizi hatırlar',
      },
      analytics: {
        title: '2. Analiz Çerezleri',
        description: 'Bu çerezler, sayfa ziyaretleri, harcanan süre ve kullanılan özellikler hakkında anonim bilgi toplayarak ziyaretçilerin web sitemizle nasıl etkileşimde bulunduğunu anlamamıza yardımcı olur.',
        provider: 'Sağlayıcı: Firebase Analytics (Google)',
        purpose: 'Amaç:',
        item1: 'Web sitesi trafiğini ve kullanıcı etkileşimini ölçme',
        item2: 'Popüler özellikleri ve sayfaları belirleme',
        item3: 'Kullanıcı demografisini anlama (yaş aralığı, genel konum)',
        item4: 'Web sitesi performansını ve kullanıcı deneyimini iyileştirme',
      },
      advertising: {
        title: '3. Reklam Çerezleri',
        description: 'Bu çerezler, sizinle ilgili reklamları görüntülemek için kullanılır. Ayrıca bir reklamı görme sayınızı sınırlar ve reklam kampanyalarının etkinliğini ölçmeye yardımcı olur.',
        provider: 'Sağlayıcı: Google AdSense',
        purpose: 'Amaç:',
        item1: 'İlgi alanlarınıza göre kişiselleştirilmiş reklamlar gösterme',
        item2: 'Reklam performansını ve etkileşimini ölçme',
        item3: 'Aynı reklamın çok fazla gösterilmesini önleme',
        note: 'Not: Premium aboneler, çerez ayarlarından bağımsız olarak hiçbir zaman reklam görmez.',
      },
    },
    firstThird: {
      title: 'Birinci Taraf vs Üçüncü Taraf Çerezler',
      firstParty: {
        title: 'Birinci Taraf Çerezler',
        description: 'Bunlar doğrudan Zodiac Chess tarafından ayarlanan çerezlerdir. Bunları temel site işlevselliği, kimlik doğrulama ve tercihlerinizi hatırlamak için kullanıyoruz.',
      },
      thirdParty: {
        title: 'Üçüncü Taraf Çerezler',
        description: 'Bunlar, Google Analytics ve Google AdSense gibi kullandığımız harici hizmetler tarafından ayarlanan çerezlerdir. Üçüncü taraf çerezleri, bu sağlayıcıların gizlilik politikalarına tabidir.',
      },
    },
    specific: {
      title: 'Kullandığımız Özel Çerezler',
      tableHeader: 'Web sitemizde kullanılan çerezlerin ayrıntılı listesi aşağıdadır:',
    },
    control: {
      title: 'Çerezleri Nasıl Kontrol Edebilirsiniz',
      consent: {
        title: '1. Çerez Onay Afişi',
        description: 'Web sitemizi ilk ziyaret ettiğinizde, bir çerez onay afişi göreceksiniz. Şunları yapabilirsiniz:',
        item1: 'Tümünü Kabul Et - Tüm çerezlere izin ver (gerekli, analiz ve reklam)',
        item2: 'İsteğe Bağlıları Reddet - Yalnızca gerekli çerezlere izin ver (analiz veya reklam yok)',
        item3: 'Özelleştir - Hangi çerez türlerine izin vermek istediğinizi tam olarak seçin',
      },
      browser: {
        title: '2. Tarayıcı Ayarları',
        description: 'Çoğu web tarayıcısı, ayarları aracılığıyla çerezleri kontrol etmenize olanak tanır. Şunları yapabilirsiniz:',
        item1: 'Tüm çerezleri engelle',
        item2: 'Yalnızca birinci taraf çerezleri kabul et',
        item3: 'Her tarama oturumundan sonra çerezleri sil',
        item4: 'Bireysel çerezleri görüntüle ve sil',
        links: 'Popüler tarayıcılar için çerez yönetimi bağlantıları:',
      },
      optOut: {
        title: '3. Devre Dışı Bırakma Araçları',
        description: 'Özellikle reklam çerezleri için kişiselleştirilmiş reklamları devre dışı bırakabilirsiniz:',
        googleLink: 'Google Reklam Ayarları',
        googleDesc: ' - Google kişiselleştirilmiş reklamları yönetin',
        daaLink: 'Digital Advertising Alliance (DAA)',
        daaDesc: ' - İlgi alanına dayalı reklamcılığı devre dışı bırakın',
        edaaLink: 'European Interactive Digital Advertising Alliance (EDAA)',
        edaaDesc: ' - AB\'ye özgü devre dışı bırakma aracı',
      },
    },
    impact: {
      title: 'Çerezleri Devre Dışı Bırakmanın Etkisi',
      p1: 'Çerezleri devre dışı bırakır veya reddederseniz, lütfen şunları unutmayın:',
      item1: 'Web sitesinin bazı bölümleri düzgün çalışmayabilir',
      item2: 'Her ziyarette tercihlerinizi yeniden girmeniz gerekebilir',
      item3: 'Hesabınızdan çıkış yapılabilir',
      item4: 'Sitenin çalışması için gerekli çerezler gereklidir - bunları devre dışı bırakmak temel özellikleri kullanmanızı engelleyecektir',
    },
    updates: {
      title: 'Bu Çerez Politikasındaki Güncellemeler',
      p1: 'Uygulamalarımızdaki değişiklikleri yansıtmak veya yasal, düzenleyici veya operasyonel nedenlerle bu Çerez Politikasını zaman zaman güncelleyebiliriz.',
      p2: 'Önemli değişiklikleri bu sayfanın üst kısmındaki "Son Güncelleme" tarihini güncelleyerek size bildireceğiz. Lütfen bu politikayı düzenli olarak gözden geçirin.',
    },
    contact: {
      title: 'Bize Ulaşın',
      p1: 'Çerez kullanımımız veya bu Çerez Politikası hakkında sorularınız varsa, lütfen bizimle iletişime geçin:',
      email: 'E-posta:',
      company: 'Şirket:',
    },
  },

  // Game
  game: {
    yourTurn: 'Your Turn',
    opponentTurn: "Opponent's Turn",
    victory: 'Victory!',
    defeat: 'Defeat',
    draw: 'Draw',
    resign: 'Resign',
    offerDraw: 'Offer Draw',
  },

  // Game End
  gameEnd: {
    victory: 'ZAFER!',
    defeat: 'YENİLGİ!',
    draw: 'BERABERE!',
    wonBy: '{condition} ile kazandı',
    lostBy: '{condition} ile kaybetti',
    drawBy: '{condition} ile berabere',
    youCapturedTheirKing: 'You captured their {piece} King!',
    yourKingWasCaptured: 'Your {piece} King was captured!',
    rematchButton: 'Rematch',
    backButton: 'Back',
    conditions: {
      kingslayer: 'Kral Katili',
      race: 'Yarış Zaferi',
      timeout: 'Süre Doldu',
      threefold: '3x Tekrar',
      noMoves: 'Geçerli Hamle Yok',
      draw: 'Berabere',
    },
  },

  // Game Info
  gameInfo: {
    title: 'Game Info',
    sandboxMode: 'Sandbox Mode',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
    yourTurn: 'Your turn',
    opponentTurn: "Opponent's turn",
    aiThinking: 'AI thinking...',

    // Selection states
    selecting: 'Selecting {piece}',
    observing: 'Observing {piece}',
    selectingZombified: 'Selecting zombified enemy {piece}',
    selectionLocked: 'Selection locked on {piece}',
    selectionLockedPenguin: 'Penguin is selection locked',

    // Hints
    clickToFaint: 'Click on {piece} to faint',
    clickToRotate: 'Click on the {piece} to rotate',
    clickToInk: 'Click on the {piece} to ink',
    zombifiedWarning: '⚠️ While zombified, {piece} rotates before moving!',

    // Monkey bonus turn
    monkeySwing: 'Monkey completed swing, please move your Monkey to complete bonus turn',
    monkeyConsume: 'Monkey consumed fungi, please move your Monkey to complete bonus turn',

    // Virus bonus turn
    virusInfecting: 'Virus is infecting, continue turn or click on virus to end turn',

    // Penguin bonus turn
    penguinRotate: 'Penguin completed slide - please choose final rotation direction',
    penguinCaptureRotate: 'Penguin completed capture - please choose final rotation direction',
    penguinZombified: 'Zombified Penguin rotated - complete turn with slide/capture (zombification will end)',

    // Capture restrictions
    cannotCapture: '{piece} cannot capture: {targets}',
    cannotInfect: '{piece} cannot infect: {targets}',
    cannotEntangle: '{piece} cannot entangle: {targets}',
    monkeyBearRoll: '{piece} must roll 5-6 to capture enemy {target}',
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',

    // Meadow warning (Tree immobilization)
    meadowWarning: '{piece} is immobilized by enemy {fungi}',
    rhinoChargeWarning: '{piece} charge does not affect: {targets}',
    snakeStrikeWarning: '{piece} strike does not affect: {targets}',
  },

  // Piece names
  pieces: {
    Bear: 'Ayı',
    Crane: 'Turna',
    Frog: 'Kurbağa',
    Fungi: 'Mantar',
    Goat: 'Keçi',
    Monkey: 'Maymun',
    Octopus: 'Ahtapot',
    Penguin: 'Penguen',
    Rhino: 'Gergedan',
    Snake: 'Yılan',
    Tree: 'Ağaç',
    Virus: 'Virüs',
    Wolf: 'Kurt',
  },

  // Short poetic vibe descriptions for landing carousel — one per variant
  pieceVibes: {
    Bear:    { light: 'Few dare approach',                   dark: 'Nothing impedes her hunger' },
    Crane:   { light: 'Sailing above, quieter than the wind',      dark: 'It circles. It waits. The lonely never return home' },
    Frog:    { light: 'Lazing on the lily pad',       dark: 'Take the colors as a warning' },
    Fungi:   { light: 'The meadow-maker',         dark: 'Consume and see who has been consumed' },
    Goat:    { light: 'Catch me on the cliff side',   dark: 'The corpse that blinks' },
    Monkey:  { light: 'Branch to branch to foe, laughing all the way',               dark: 'Roll the bones. Smiles either way' },
    Octopus: { light: 'Soft arms, razor sharp hooks, never releasing its grip',  dark: 'A bloom of black water. The shape inside is gone' },
    Penguin: { light: 'A harmless little thing in a tiny black coat',        dark: 'Slow and cute, right?' },
    Rhino:   { light: 'Waiting to face down a challenger', dark: 'Lock eyes at your peril' },
    Snake:   { light: 'Changing endings like outfits',                               dark: 'Do not tread near me' },
    Tree:    { light: 'A haven amongst the beasts',             dark: 'Standing where the dead stood. Still standing' },
    Virus:   { light: 'The battle for pandoras box',         dark: 'They feel triumph, then a cough, then silent disbelief' },
    Wolf:    { light: 'The alpha of his pack',  dark: 'When the pack is gone. What remains excites' },
  },


  // Move Context (piece descriptions)
  moveContext: {
    title: 'Move Context',
    emptyState: 'Select an ability from the left panel to view detailed information.',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'AI ARENA',
    tagline: 'Pick an AI to Battle or watch AI duke it out!',

    // Player labels
    lightPlayer: 'Light Player',
    darkPlayer: 'Dark Player',
    humanPlayer: 'Human Player',
    aiPlayer: 'AI',
    difficulty: 'Difficulty',
    difficultyEasy: 'Easy',
    difficultyMedium: 'Medium',
    difficultyHard: 'Hard',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: 'Sentinel',
    aiAlchemist: 'Alchemist',
    aiZenith: 'Zenith',
    aiTrapper: 'Trapper',
    aiHunter: 'Hunter',
    aiWisp: 'Wisp',
    aiCreature: 'Creature',
    aiWeaver: 'Weaver',

    // Time Frames
    timeFast: 'Fast',
    timeStandard: 'Standard',
    timeDeep: 'Deep',

    // Thinking time
    thinkingTime: 'Thinking Time',

    // Info box
    matchupLabel: 'Matchup:',
    statusLabel: 'Status:',
    statusPaused: 'PAUSED',
    statusAIThinking: 'AI Thinking...',
    statusInGame: 'In Game',
    statusReady: 'Ready',
    matchupLocal2P: 'Local 2P',
    matchupPlayerVs: 'Player vs',
    matchupVsPlayer: 'vs Player',

    // Buttons
    startButton: 'Start',
    startRandomButton: 'Start Random',
    newGameButton: 'New Game',
    resumeButton: 'Resume',
    pauseButton: 'Pause',
    pauseQueuedButton: 'Pause (queued...)',
    viewKingsButton: 'View Kings',
    hideKingsButton: 'Hide Kings',
    viewKingsQueuedButton: 'View Kings (queued...)',
    hideKingsQueuedButton: 'Hide Kings (queued...)',
    homeButton: 'Home',
    toggleKingVisibility: 'Toggle king visibility',

    // Warning modal
    invalidPlacement: 'Invalid Placement',
    okButton: 'OK',
    warningLightTurn: "It's Light player's turn to place a piece!",
    warningDarkTurn: "It's Dark player's turn to place a piece!",
    warningLightRow: 'Light pieces must be placed on row 0 (your home row)!',
    warningDarkRow: 'Dark pieces must be placed on row 7 (your home row)!',
    warningOccupied: 'This square is already occupied! Choose an empty square.',
    warningKingRequired: 'You must place your king ({kingType}) before placing your 5th piece!',

    // Piece selection
    dragPieces: 'Drag pieces to the board',
    lightPieces: 'Light Pieces',
    darkPieces: 'Dark Pieces',

    // Mobile
    selectYourKing: 'Select Your King',
    selectPieceToPlace: 'Select Piece to Place',
    moveHistory: 'Move History',
    historyButton: 'History',
    backButton: 'Back',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
  },

  // Upgrade Modal
  upgrade: {
    title: 'Premium\'a Yükselt',
    accountRequired: 'Premium\'a yükseltmeden önce kalıcı bir hesap oluşturmanız gerekiyor.',
    createAccountPrompt: 'İlerlemenizi kaydetmek ve premium özelliklerin kilidini açmak için bir hesap oluşturun!',
    subtitle: 'Zodiac Chess deneyiminizi geliştirmek için güçlü özelliklerin kilidini açın!',
    features: {
      history: 'Hesap Geçmişi',
      historyItem1: 'Tüm önceki oyunlarınızı saklayın ve geri çağırın',
      historyItem2: 'Stratejiyi değerlendirmek için eski oyunlarınızı herhangi bir noktadan tekrar oynayın',
      historyItem3: 'Tahta pozisyonlarını ve parlak hamle fırsatlarını analiz etmek için derin analitiği kullanın',
      analytics: 'Analitik',
      analyticsItem1: 'Oyun istatistiklerine erişin',
      analyticsItem2: 'Kullanıcıların taş ve kral seçimlerini tonlarca metrik üzerinden analiz edin',
      analyticsItem3: 'Hangi metaların popüler olduğunu ve neyin işe yaradığını öğrenin!',
      course: 'Kurs',
      courseItem1: 'Becerilerinizi geliştirmek için güncel kurslara erişin',
      courseItem2: 'Profesyonellerden meta ve kavramları öğrenin',
      courseItem3: 'Kendi zayıflıklarınızı analiz etmek için oyununuz hakkında ipuçları alın',
    },
    createAccount: 'Hesap Oluştur',
    upgradeNow: 'Şimdi Yükselt',
    cancel: 'İptal',
  },

  // Premium Modal
  premium: {
    title: 'Premium Özellik',
    accessDenied: 'Üzgünüz, premium hesabınız yok, bu özelliklere henüz erişiminiz yok!',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: 'Hay Aksi! Bir Şeyler Ters Gitti',
    errorMessage: 'Ödemenizi işlerken bir sorunla karşılaştık. Endişelenmeyin, ücret kesilmedi.',
    whatHappened: 'Ne oldu?',
    notCompleted: 'Ödemeniz tamamlanmadı. Bu şunlardan kaynaklanabilir:',
    reasons: {
      cancelled: 'Ödeme iptal edildi',
      declined: 'Kart reddedildi',
      connection: 'Ödeme sırasında bağlantı sorunu',
      expired: 'Oturum süresi doldu',
    },
    whatToDo: 'Ne yapabilirsiniz?',
    actions: {
      tryDifferentCard: 'Farklı bir kartla tekrar deneyin',
      tryDifferentCardDesc: 'Başka bir ödeme yöntemi kullanın',
      retryPayment: 'Ödemeyi tekrar deneyin',
      retryPaymentDesc: 'Bazen basit bir yeniden deneme işe yarar',
      checkBank: 'Bankanızla kontrol edin',
      checkBankDesc: 'Kartınızda yeterli bakiye olduğundan emin olun',
    },
    tryAgain: 'Yükseltmeyi Tekrar Dene',
    returnHome: 'Ana Sayfaya Dön',
    contactSupport: 'Yardıma mı ihtiyacınız var? support@zodiac-chess.com adresinden destek ile iletişime geçin',
  },

  // Donation
  donation: {
    title: 'Support Zodiac Chess',
    supportDevelopment: 'Support Development',
    story1: "Hi! Your support helps me continue improving this unique game! Adding new features, maintaining servers, and keeping Zodiac Chess free for the community.",
    story2: "Even a small donation makes a huge difference and keeps this project alive. Thank you for being part of the Zodiac Chess journey :)",
    selectAmount: 'Choose Amount',
    customAmount: 'Or enter custom amount:',
    total: 'Total:',
    donateButton: 'Donate Now',
    processing: 'Processing...',
    disclaimer: 'Donations support development and server costs. Thank you for your generosity!',
    invalidAmount: 'Please enter a valid amount greater than $0',
    error: 'There was an error processing your donation. Please try again.',
  },
  howToPlay: {
    whatIsZodiac: 'Bu Ne Hakkında?',
    gameSetup: 'Oyun Kurulumu',
    basicRules: 'Temel Kurallar',
    backButton: 'GERİ',
    homeButton: 'Ana Sayfa',
    fullRules: 'Tam Kurallar',
    whatIs: {
      p1: 'Zodiac Chess, geleneksel taşlar yerine 13 benzersiz hayvan taşı olan bir satranç varyasyonudur.',
      p2: 'Her hayvanın karmaşık stratejik olasılıklar yaratan özel yetenekleri ve hareketleri vardır.',
      p3: 'Oyun 5x8 boyutunda bir tahtada iki takımla oynanır: Açık ve Koyu.',
      p4: 'Her takım ilk sıralarına yerleştirilmiş 5 taşla başlar.',
      p5: 'Amaç rakip şahı ele geçirmek veya şahınızı karşı tarafa koşturmaktır.',
      p6: 'Zodiac Chess ustası olmak için her taşı öğrenin!',
    },
    setup: {
      p1: 'Tahta 5 sütun genişliğinde ve 8 sıra yüksekliğindedir.',
      p2: 'Açık taşlar altta, koyu taşlar üstte başlar.',
      p3: 'Her takımın başlangıçta tam olarak 5 taşı vardır.',
      p4: 'Her takımdan bir taş Şah olarak belirlenir.',
      p5: 'Şah taşı herhangi bir hayvan olabilir (Virüs hariç).',
      p6: 'Oyun çeşitli taş kompozisyonlarıyla rastgele başlangıçlar sunar.',
    },
    rules: {
      intro: 'Oyun için temel kurallar:',
      toWinTitle: 'Kazanmak İçin:',
      toWin1: 'Rakip şahı ele geçirin',
      toWin2: 'Şahınızı tahtanın karşı tarafına ulaştırın',
      toWin3: 'Aynı turda hem sizin şahınız hem de rakip şah ele geçirilirse, son yakalayan kazanır',
      toWin4: 'Bir kazanma koşulu sağlandığında maçlar hemen sona erer',
      drawTitle: 'Beraberlik:',
      draw1: 'Beraberlikler üç kez tekrar veya pat durumunda olur',
      draw2: 'Oyuncular ayrıca beraberlik konusunda anlaşabilir',
    },
    tutorials: {
      bear: {
        desc1: 'Normal hareket - Ayı herhangi bir yönde bir kare hareket edebilir',
        desc2: 'Ayının "Vahşi" yeteneği, savunma yeteneklerinden bağımsız olarak herhangi bir taşı yakalamasına izin verir',
        desc3: 'Ayı bir "büyük" taş ve "avcı" taştır, bu da diğer birçok Zodyak\'ın onu yakalayamayacağı anlamına gelir!',
      },
      crane: {
        desc1: 'Turna normal hareketi için herhangi bir düz çizgide 1 veya 2 kare hareket edebilir',
        desc2: 'Turna herhangi bir "büyük" veya "avcı" taşı yakalayamaz',
      },
      frog: {
        desc1: 'Kurbağa normal hareketi için çaprazlarda 2 kare zıplayabilir, diğer taşların üzerinden bile!',
        desc2: 'Kurbağanın normal hareketi bir duvar veya yakalayamayacağı bir taş tarafından engellenirse, normal hareketi 1 kare çapraza düşer',
        desc3: 'Kurbağa oyunda henüz bir hamle yapmadıysa, "nilüfer yaprağı" üzerindedir ve savunma hareketi olarak ilk 3 sıradan herhangi birine hareket edebilir',
        desc4: 'Bir taş kurbağayı yakalarsa, zehirlenir ve bir sonraki müsait turunda hiçbir hamle yapamaz',
        desc5: 'Kurbağanın özel hareketi "duvar tırmanışı"dır - eğer bir kurbağa tahtanın kenarındaysa, bir yukarı veya aşağı da hareket edebilir',
      },
      fungi: {
        desc1: 'Mantar normal hareketi için herhangi bir yönde bir kare hareket edebilir',
        desc2: 'Mantarın "çayır" yeteneği, mantarın bir karesi içindeyse bir ağacın hareket etmesini engeller ve bir ağacın düşman mantarın bir karesi içine hareket etmesine izin vermez',
        desc3: 'Yakalandığında mantar, onu yakalayan herhangi bir hayvan taşına "zombi" etkisi uygular',
        desc4: 'Zombi olurken, mantar taşı sonraki tur için kontrol eder ve taş gibi davranır, yani mantar şahınızsa, o turda yarış zaferi veya düşman şahı yakalayarak hala kazanabilirsiniz',
      },
      goat: {
        desc1: 'Keçi normal hareketi için herhangi bir yönde bir kare hareket edebilir',
        desc2: 'Keçinin "geçiş" yeteneği, bağlı taşların üzerinden atlamasına ve sonra hareket etmesine izin verir, geçişte hiçbir taşı yakalayamaz',
        desc3: 'Keçi hiçbir "avcıyı" yakalayamaz',
        desc4: 'Keçi, kendini ölü gibi göstermek için "bayılma" adlı özel bir yetenek kullanabilir',
        desc5: 'Bayılmışken, keçi çoğu taş tarafından yakalanamaz ama başka bir taş üzerinde "duruyorsa" (aynı karede) hareket edemez',
      },
      monkey: {
        desc1: 'Maymun normal hareketi için herhangi bir yönde bir kare hareket edebilir',
        desc2: 'Maymun, formasyon izin veriyorsa dama taşı gibi dost ve düşman taşların üzerinden "atlayabilir"',
        desc3: 'Maymun düşman taşının üzerinden atlarsa, yakalanmamak için zar atması gerekir! Tek bir çizgide atladığı her düşman taşı için bir tehlike puanı',
        desc4: 'Maymun, saldırmak için kumar oynamaya karar verirse bir ayıyı yakalayabilir, altı yüzlü zarda 1-4 atışta Maymun yakalanır, 5 veya 6\'da Maymun ayıyı yakalar',
        desc5: 'Maymunun iki yeteneği vardır - "sallanma" ve "tüketme", bir sallanmada (bir ağacın üzerinde biten bir atlama), maymun ekstra hareket kazanır, herhangi bir mantarı tüketmede, maymun turları bitmeden önce bir ekstra hareket daha kazanır',
      },
      octopus: {
        desc1: 'Ahtapot normal hareketi için herhangi bir yönde bir kare hareket edebilir',
        desc2: 'Ahtapot sadece dikey/yatay karelerde yakalayabilir',
        desc3: 'Ahtapot, çapraz karelerdeki herhangi bir hayvan taşına "dolaştırma" yeteneğini kullanabilir',
        desc4: 'Ahtapot bir turda herhangi bir hamle yapabilir VE dolaştırabilir',
        desc5: 'Ahtapotun "mürekkep" adlı bir yeteneği vardır, bu yetenekle herhangi bir dikey/yatay kareye hareket edebilir ve eğer dolu değilse veya tahtanın dışında değilse diğer 3 dikey/yatay kareye "gölgeler" yerleştirebilir. "Mürekkep" yeteneğini izleyen tur için rakibe gölgeler ve gerçek ahtapot ayırt edilemez',
      },
      penguin: {
        desc1: 'Penguenin "döndürme" adlı bir yeteneği vardır, belirli bir yönü olan ve turu için yönünü yeniden yönlendirmek için "döndürme" hareketini kullanabilen tek taştır',
        desc2: 'Penguenin normal hareketi "kayma" için, baktığı yönde en uzak noktaya hareket etmesi gerekir ve oraya vardığında, yönünü yeniden yönlendirmek için turu bitmeden önce bir döndürme kullanabilir',
        desc3: 'Penguen hiçbir "büyük" veya "avcı" taşı yakalayamaz. Kendisinden bir kare içindeki diğer herhangi bir taşı yakalayabilir ve yakalamadan sonra döndürme yeteneği kullanabilir',
      },
      rhino: {
        desc1: 'Gergedan normal hareketinin bir parçası olarak "sol geri", "sağ geri" veya iki ileri hareket edebilir',
        desc2: 'Gergedanın "çiğneme" adlı bir yeteneği vardır, hareketinin yolundaki TÜM taşları yakalar',
        desc3: 'Oyun başına bir kez gergedan, gergedanın tam önündeki 3 kareden herhangi birinde bir hayvan varsa 3 kare ileride şarj yapabilir',
        desc4: 'Gergedanın "gergedan savunması" adlı özel bir yeteneği vardır, gergedan "önden" yakalanamaz',
        desc5: 'Gergedanın "şerit" adlı bir yeteneği vardır, eğer hareket etmediyse ve tam solundaki veya sağındaki dost taş hareket etmediyse, turu için o taşla yer değiştirebilir',
      },
      snake: {
        desc1: 'Yılan normal hareketi için sadece dikey/yatay yönlerde 2 kare hareket edebilir, diğer taşların içinden dahil',
        desc2: 'Normal hareketi bir duvar veya yakalayamayacağı bir taş tarafından engellenirse, normal hareketi 1 olur',
        desc3: 'Yılanın "vuruş" adlı bir yeteneği vardır, tam 3 kare ilerisinde bir hayvan varsa ve arada hiçbir taş yoksa, ileriye "vurup" o hayvanı yakalayabilir',
        desc4: 'Yılanın "deri değiştirme" adlı bir yeteneği vardır, oyun başına bir kez yılan yakalanırsa, sanki ikinci bir hayatı varmış gibi tahtanın ilk sırasına, aynı sütuna geri dönecektir. İlk sıra yılanın hareket edeceği geçerli bir kare değilse, kalıcı olarak yakalanır',
      },
      tree: {
        desc1: 'Ağaç bir ileri veya başka bir taş tarafından engellenmezse sınırsız şekilde yanlara hareket edebilir',
        desc2: 'Ağacın "ev" adlı özel bir yeteneği vardır, ağaçlara "tırmanabilen" herhangi bir taş ağaç taşının üstüne oturabilir. Düşman taş, içinde taş barındıran bir ağaca saldırırsa, barındırılan taş yakalanır ve ağaç düşman taşı barındırır',
        desc3: 'Bir taş ağaçta barındırıldığında, düşman taş ağaca tırmanamıyorsa, hem ağaç hem de barındırılan taş yakalanmaktan korunur',
      },
      wolf: {
        desc1: 'Kurt normal hareketi için satrançtaki at gibi L şeklinde hareket eder',
        desc2: 'Kurt tahtadaki son taşsa*, "yalnız kurt" yeteneği aktive olur ve yukarıda resimde gösterildiği gibi bunun yerine uzun L\'de hareket eder. *Kurt, bayılmış keçi veya enfekte eden virüsle bir takımdaysa yalnız moduna girer',
      },
      virus: {
        desc1: 'Virüs normal hareketi için herhangi bir düz çizgide 2 kare hareket edebilir, yakalamaz ama taşın yakalanmak yerine enfekte olması için "enfekte" yeteneğini kullanır',
        desc2: 'Virüs sadece herhangi bir hayvan taşına hareket edebilir, bir duvar tarafından engellenirse, virüsün normal hareketi sadece 1 karedir',
        desc3: 'Bir hayvan taşı "enfekte" olduğunda, virüs enfekte taştan başka bir taşa geçerse, bıraktığı taş yakalanır ve yeni taş "enfekte" olur',
        desc4: 'Virüsün "bulaşıcı" adlı bir yeteneği vardır, bu yetenek virüsün bir hamlede istediği kadar geçerli hamle tamamlamasına izin verir, bir turda birden fazla hayvanı yakalar',
        desc5: '"Enfekte" etmezken, virüs diğer herhangi bir taş gibi yakalanabilir. Bir hayvan enfekte bir taşı yakalarsa, enfekte olur',
      },
    },
  },
};

